import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function SEOArticlesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-primary-600 mb-2 font-[family-name:var(--font-label)]">
              SEO Content Hub
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 italic">
              OOPBuy Spreadsheet Ratgeber
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md font-[family-name:var(--font-body)]">
            Unsere Experten-Artikel helfen dir, das Beste aus deinem OOPBuy Spreadsheet herauszuholen. Von Anfänger-Guides bis zu Profi-Tipps.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticleCard({ article }: { article: typeof seoArticles[0] }) {
  const content = (
    <div className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer h-full flex flex-col">
      <div className="aspect-[3/2] overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={`OOPBuy Spreadsheet - ${article.title}`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium font-[family-name:var(--font-label)]">
            {article.tag}
          </span>
          <span className="text-xs text-foreground-400 font-[family-name:var(--font-label)]">
            {article.readingTime}
          </span>
        </div>
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug font-[family-name:var(--font-heading)] group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1 line-clamp-3 font-[family-name:var(--font-body)]">
          {article.excerpt}
        </p>
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:gap-2 transition-all font-[family-name:var(--font-label)]">
          {article.external ? 'Jetzt Entdecken' : 'Artikel Lesen'}
          <i className={`${article.external ? 'ri-external-link-line' : 'ri-arrow-right-line'} text-sm`}></i>
        </span>
      </div>
    </div>
  );

  if (article.external) {
    return (
      <a href={article.link} target="_blank" rel="noopener nofollow">
        {content}
      </a>
    );
  }

  return (
    <Link to={article.link}>
      {content}
    </Link>
  );
}